import {Directive, HostListener, Input} from '@angular/core';

@Directive({
	selector: '[framework-input]'
})
/**
 * Directive to restrict input based on specified type.
 *
 * This directive listens to 'keydown' and 'paste' events on an input element
 * and restricts the input based on the 'framework-input-type' attribute.
 *
 * Supported types:
 * - "DTY_NVAR": Allows any input.
 * - "FLT_STRING": Allows any input.
 * - "DTY_FLOAT": Allows numeric input and a single decimal point.
 *
 * On 'keydown', it prevents input of characters not allowed by the specified type.
 * On 'paste', it validates the pasted content against the allowed pattern for the type.
 *
 * @input {string} framework-input-type - The type of input restriction to apply.
 */
export class FrameworkTypeDirective
{

	@Input('framework-input-type') inputType  = "DTY_NVAR";

	@HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent)
	{

		if(this.inputType.length===0 || this.inputType === "DTY_NVAR" || this.inputType === "FLT_STRING"){
			return; //If the input is String nothing to do, all is allowed
		}

		const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

		if (this.inputType === "DTY_FLOAT")
		{
			allowedKeys.push('.'); //If is decimal also . is a valid character
		}

		const isAllowedKey = allowedKeys.includes(event.key);

		//Current value of inout element
		const inputElement = event.target as HTMLInputElement;
		const currentValue = inputElement.value;

		//Decimal
		if (this.inputType === "DTY_FLOAT")
		{
			if (event.key === '.' && currentValue.includes('.'))
			{
				event.preventDefault();
				return;
			}
		}

		//Check for decimal and number
		if (
			isAllowedKey ||
			(event.key >= '0' && event.key <= '9')
		)
		{
			return; //Allow insert
		}
		else
		{
			event.preventDefault(); //Block insert of other character
		}
	}

	@HostListener('paste', ['$event']) onPaste(event: ClipboardEvent)
	{
		if(this.inputType.length===0 || this.inputType === "DTY_NVAR" || this.inputType === "FLT_STRING"){ //If the input is String nothing to do
			return;
		}

		const clipboardData = event.clipboardData?.getData('text') || '';
		if (clipboardData)
		{
			let regex : RegExp | null = null;
			if( this.inputType === 'DTY_FLOAT'){
				regex =/^\d*\.?\d*$/;
			}else if(this.inputType === 'DTY_INT'){
				regex = /^\d+$/;
			}
			if (regex && !regex.test(clipboardData))
			{
				event.preventDefault(); //Block invalid content
			}
		}
	}
}